import styled from "styled-components";
import { DrillDownGlyph } from "../molecules/ChartPointActionMenu/ChartPointActionMenu.styles";

const PX_PER_REM = 16;

/** The drill glyph at a caller's size (px, like a lucide icon's `size`), drawn in its parent's colour. */
export const SizedDrillGlyph = styled(DrillDownGlyph)<{ $size: number }>`
  width: ${({ $size }) => $size / PX_PER_REM}rem;
  height: ${({ $size }) => $size / PX_PER_REM}rem;
`;
